import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useDashboardMenuItems } from 'hooks/config';
import { MenuItem } from 'types/menu';

const WebView = (): JSX.Element => {
  const { t } = useTranslation();
  const { key } = useParams();
  const correspondingMenuItem = findCorrespondingMenuItem(key ? "iframe:" + key : 'unknown', useDashboardMenuItems());
  const url = correspondingMenuItem?.url;

  return (
    <>
      <Helmet>
        <title>{correspondingMenuItem?.label}</title>
      </Helmet>

      {url ? 
      (<iframe src={url} width={'100%'}></iframe>) : 
      (<p>Webpage not found</p>)}
    </>
  );
};

function findCorrespondingMenuItem(ref : string, items : MenuItem[]) : MenuItem | undefined {
  if (items.length === 0) return undefined;
  var item = items.find(item => item.key === ref);
  if (item !== undefined) return item;
  return findCorrespondingMenuItem(
    ref,
    items.flatMap(item => item?.children ? item.children : [])
  );
}

export default WebView;